module.exports = __webpack_public_path__ + "static/media/ami_img_landing_mobile.9a0c7b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_img_landing_mobile.png
// module id = 1441
// module chunks = 1